
























import Vue from 'vue'
import FinalOutputPlayer from '@/components/FinalOutputPlayer'
import VideoObject, { VideoObjectConfig } from '@/classes/VideoObject'
import { SystemStatus } from '@/types/ops'
import './Preview.scss'
import { Cast } from '@/types/casts'
import { UserProfile } from '@/types/users'
import { StreamVariant } from '@/types/streams'
import { KeyDict } from '@/types'

export default Vue.extend({
  name: 'PreviewOutput',
  data: () => ({
    audioContext: null as null | AudioContext,
    audioInit: false,
    castLoaded: false,
    streamsManager: {} as KeyDict<VideoObject>,
    castAudioActive: '', // contains cast id
    activePreviews: [],
    videoObjects: [] as VideoObject[],
    castId: ''
  }),
  created (): void {
    this.audioContext = new AudioContext()
    document.querySelector('body')?.addEventListener('click', () => {
      this.audioContext?.resume()
    })
    this.init()
  },
  watch: {
    currentCast (): void {
      this.castLoaded = true
    }
  },
  computed: {
    currentCast (): Cast {
      return this.$store.direct.state.events.currentCast
    },
    userProfile (): UserProfile|null {
      return this.$store.direct.state.user.profile
    },
    finalPreviewStream (): string {
      let stream = ''
      if (this.currentCast?.output_streams !== undefined) {
        if (this.currentCast.output_streams.rtsphighres !== undefined) {
          if (this.currentCast.output_streams.rtsphighres.ngcvp_status === SystemStatus.OK) {
            stream = this.currentCast.output_streams.rtsphighres.stream
          }
        }

        if (!stream && this.currentCast.output_streams.rtsplowres !== undefined) {
          if (this.currentCast.output_streams.rtsplowres.ngcvp_status === SystemStatus.OK) {
            stream = this.currentCast.output_streams.rtsplowres.stream
          }
        }
      }
      return stream
    },
    isHighRes (): boolean {
      return !!this.finalPreviewStream && this.finalPreviewStream.includes('highres')
    },
    castTitle (): string {
      return !!this.currentCast && this.currentCast.name
    },
    isActive (): boolean {
      if (!this.currentCast || !this.currentCast.start_date || !this.currentCast.end_date) {
        return true
      }

      const now = new Date()
      const startDate = new Date(this.currentCast.start_date.seconds * 1000)
      const endDate = new Date(this.currentCast.end_date.seconds * 1000)
      return now >= startDate && now <= endDate
    }
  },
  methods: {
    async init (): Promise<void> {
      const castId = this.$route.params.id
      if (castId !== undefined && castId.length === 20) {
        this.castId = castId
        await this.$store.direct.dispatch.events.setInCast(true)
        await this.$store.direct.dispatch.events.subscribeCurrentCast(this.castId)
        await this.$store.direct.dispatch.events.subscribeCurrentPlaylist(this.castId)
      } else {
        await this.$router.push({ path: '/404' })
      }
    },
    addOutputVideo (vid: { video: string, variant: StreamVariant }): void {
      if (!this.streamsManager.hasOwnProperty(vid.video)) {
        Vue.set(this.streamsManager, vid.video, {})
        this.makeVideoObject(vid.video, vid.variant)
      }
    },
    makeVideoObject (id: string, variant: StreamVariant): void {
      const vidConfig: VideoObjectConfig = {
        id: id,
        name: id,
        logNetwork: false,
        streamToPlay: variant,
        udpEnabled: this.userProfile?.udpEnabled ?? false,
        callback: (stream) => Vue.set(this.streamsManager, id, stream),
        killStream: (stream) => {
          try {
            const video = this.streamsManager[stream.id]
            if (video !== undefined) video.stopPlay()
          } catch (e) {}
          this.$delete(this.streamsManager, stream.id)
        },
        restartStream: (stream) => console.log('restartStream', stream)
      }
      const vidObject = new VideoObject(vidConfig)
      this.videoObjects.push(vidObject)
    },
    muteStatus (castId: string): boolean {
      return this.castAudioActive !== castId
    },
    setAudioSource (castId: string): void {
      this.castAudioActive = (this.castAudioActive !== castId) ? castId : ''
    }
  },
  components: {
    FinalOutputPlayer
  }
})
